import { useCallback } from 'react';
import type { JSX } from 'react';

import { Loader } from '@change-corgi/design-system/components/progressiveDisclosure';
import { Box } from '@change-corgi/design-system/layout';

import { LazyComponent } from 'src/app/shared/components/layout/lazy';

import type { AIResultsDraftStep } from './AIResultsDraft';

async function LoadAIResultsDraftStep(): Promise<typeof AIResultsDraftStep> {
	return (await import(/* webpackChunkName: "pages/start-a-petition-steps-ai-results-draft" */ './AIResultsDraft'))
		.AIResultsDraftStep;
}

export function AIResultsDraftLoader(): JSX.Element {
	const loadComponent = useCallback(LoadAIResultsDraftStep, []);

	return (
		<LazyComponent
			loadComponent={loadComponent}
			fallback={
				<Box margin="auto">
					<Loader />
				</Box>
			}
		/>
	);
}

export const preloadAIResultsDraftStep = LoadAIResultsDraftStep;
